import { useState, useCallback } from 'react'
import { ISearchedMotorCarrier } from '../components/carrier-search/types'

interface IUseCarrierListProps {
  defaultValue?: ISearchedMotorCarrier[]
}

/**
 * Stores simple state around adding/removing carriers from a list
 */
export const useCarrierList = ({ defaultValue = [] }: IUseCarrierListProps = {}) => {
  const [carriers, setCarriers] = useState<ISearchedMotorCarrier[]>(defaultValue)

  const addCarrier = useCallback((carrier: ISearchedMotorCarrier) => {
    return setCarriers(prev => {
      if (prev.includes(carrier)) return prev
      return [...prev, carrier]
    })
  }, [])

  const removeCarrierByIndex = useCallback((index: number) => {
    return setCarriers(prev => prev.filter((item, i) => i !== index))
  }, [])

  const removeCarrier = useCallback((carrier: ISearchedMotorCarrier) => {
    return setCarriers(prev => prev.filter(p => p.legalName !== carrier.legalName))
  }, [])

  return {
    addCarrier,
    removeCarrier,
    removeCarrierByIndex,
    carriers,
  }
}
